import styled from 'styled-components';
import Dropzone from 'react-dropzone';

export default styled(Dropzone)`
  border: none;
  cursor: pointer;
  user-select: none;
  align-content: center;
  float: left;
  clear: left;

  input {
    max-width: ${({ size }) => size};
  }

  div {
    width: 100% !important;
  }
`;
